<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>
      <h1>{{ "repository.addresses.title" | translate }}</h1>
    </mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-tab-group>
      <mat-tab [label]="'repository.addresses.tabs.addresses' | translate">
        <div class="tab-content">
          <app-addresses></app-addresses>
        </div>
      </mat-tab>
      <mat-tab [label]="'repository.addresses.tabs.groups' | translate">
        <div class="tab-content">
          <app-address-groups></app-address-groups>
        </div>
      </mat-tab>
    </mat-tab-group>
  </mat-card-content>
</mat-card>
